export default {
  // 表单字段标签 — Phase 2 逐步填充
  bizOrderNo: '业务委托号',
  productOrderNo: '产品委托号',
  mawbNo: '主单号',
  hawbNo: '分单号',
  hawbSelection: '有无分单',
  hasHawb: '有分单',
  noHawb: '无分单',
  agreementOrderNo: '协议委托号',
  customer: '客户',
  customerName: '客户名称',
  departAirport: '出发机场',
  arriveAirport: '到达机场',
  flightDate: '航班日期',
  flightNo: '航班号',
  grossWeight: '毛重',
  chargeWeight: '计费重量',
  volume: '体积',
  pieceCount: '件数',
  cargoType: '货物类型',
  productType: '产品类型',
  customerSource: '客户来源',
  transportMode: '运输方式',
  region: '区域',
  destination: '目的区域',
  currency: '币种',
  issuingAirline: '签发航司',
  palletType: '板位类型',
  legalEntityRelation: '法人关系',
  realName: '姓名',
  username: '用户名',
  email: '邮箱',
  phone: '手机号',
  oldPassword: '旧密码',
  newPassword: '新密码',
  confirmPassword: '确认密码',
  role: '角色',
  profitAmount: '分润金额',
  percentage: '比例',
  profitDetail: '分润明细',
  // BizOrderDetailDialog 字段
  clientRefNo: '客户参考号',
  contractType: '合同类型',
  customerCode: '客户代码',
  customerLevel: '客户等级',
  paymentTerms: '付款方式',
  salesOwner: '销售归属',
  contactName: '联系人',
  contactPhone: '联系电话',
  contactAddress: '联系人地址',
  customsType: '报关方式',
  creatorName: '客服人员',
  customerRemark: '客户备注',
  departure: '启运港',
  destinationPort: '目的港',
  hawbPrealertDeclared: '是否申报分单预配',
  taxFlag: '应税/免税',
  shippingTerms: '运输条款',
  serviceItems: '服务项',
  paymentMethod: '支付方式',
  orderCategory: '订单类别',
  shipperName: '发货人名称',
  shipperAddress: '发货人地址',
  shipperRegion: '发货人地区',
  shipperPhone: '发货人电话',
  shipperContact: '发货人联系人',
  shipperCity: '发货人城市',
  consigneeName: '收货人名称',
  consigneeAddress: '收货人地址',
  consigneeRegion: '收货人地区',
  consigneePhone: '收货人电话',
  consigneeContact: '收货人联系人',
  consigneeCity: '收货人城市',
  masterShipperInfo: '发货人信息',
  masterConsigneeInfo: '收货人信息',
  bookingMethod: '订舱方式',
  transitPort: '中转港',
  destinationRegion: '目的港区域',
  finalDestination: '送货地址',
  requiredDeliveryDate: 'RDL',
  totalWeight: '总重量(KG)',
  totalVolume: '总体积(CBM)',
  cargoDescription: '货物品名',
  temperatureReq: '温度要求',
  stackable: '可堆叠',
  stackDirection: '堆叠方向',
  suggestedUldType: '建议板型',
  specialRemark: '特殊备注',
  actualPieces: '实际件数',
  actualWeight: '实际重量(KG)',
  actualVolume: '实际体积(CBM)',
  actualChargeableWeight: '实际计费重(KG)',
  warehouseReceiptNo: '称重单号',
  warehouseDataStatus: '入仓数据状态',
  route: '航线',
  airline: '航司',
  sellCurrency: '卖价币种',
  sellRate: '卖价单价',
  freightSubtotal: '运费小计',
  documentFee: '制单费',
  infoTransmissionFee: '信息传输费',
  manifestFee: '舱单费',
  otherSurcharge: '其他附加费',
  totalReceivable: '总应收',
  bubbleShareRatio: '分泡比例',
  bubbleDiscountAmount: '分泡让利',
  effectiveReceivable: '分泡后应收',
  bubbleInfo: '分泡信息',
  salesBaseCost: '销售底价成本',
  salesBaseRate: '销售底价单价',
  salesBaseWeight: '销售底价重量',
  trunkCost: '干线成本',
  trunkAllocatedRate: '分摊干线单价',
  allocatedTrunkCost: '分摊干线成本',
  payableTotal: '应付合计',
  salesGrossProfit: '销售毛利',
  productGrossProfit: '产品毛利',
  lineProfit: '航线毛利',
  lineProfitShare: '航线分润(BJ)',
  salesProfitShare: '销售分润(BK)',
  firstTierProfitShare: '一级代理分润(BL)',
  internalProfitShare: '内部分润(BM)',
  feeCategory: '费用类型',
  feeDescription: '费用描述',
  chargeBasis: '计费基础',
  unitPrice: '单价',
  quantity: '数量',
  subtotal: '小计',
  discount: '折扣',
  netAmount: '净额',
  paymentStatus: '收款状态',
  vendorName: '供应商',
  feeType: '费用类型',
  amount: '金额',
  payStatus: '付款状态',
  // businessOrders/Index.vue 字段
  sellWeight: '卖价计重',
  packageType: '包装类型',
  pieceDimensions: '单件信息',
  length: '长(cm)',
  width: '宽(cm)',
  height: '高(cm)',
  volumeCbm: '体积(CBM)',
  flight: '航班',
  chargeableWeight: '计费重量',
  salesBaseCurrency: '销售底价币种',
  trunkRate: '干线成本单价',
  trunkWeight: '干线成本重量',
  trunkCostSurcharge: '干线成本附加',
  trunkTotalCost: '干线总成本',
  costCurrency: '成本币种',
  weight: '重量',
  executeTime: '执行时间',
  scenarioNumber: '分润场景',
  // businessOrders/Detail.vue 字段
  customerSegment: '客户段',
  salesBase: '销售底价',
  // productOrderRecord/Index.vue 字段
  timeRange: '时间范围',
  pallet: '板位',
  totalCargo: '总货量',
  hawbCount: '分单数',
  revenue: '营收',
  cost: '成本',
  grossProfit: '毛利',
  agreedPalletWeight: '协议板位重量',
  usedWeight: '已用重量',
  palletUsage: '板位利用率',
  salesBaseTotalCost: '销售底价总额',
  trunkCurrency: '干线币种',
  marginRate: '毛利率',
  atdTime: 'ATD时间',
  ataTime: 'ATA时间',
  routeArchive: '航线档案',
  incomeSalesBase: '收入（销售底价）',
  costTrunk: '成本（干线）',
  // users/Index.vue 字段
  organization: '组织机构',
  password: '密码',
  // dictionary/Index.vue 字段
  dictionaryCode: '字典编码',
  dictionaryName: '字典名称',
  dictionaryNameEn: '英文名称',
  dictionaryDescription: '描述',
  dictionaryDescriptionEn: '英文描述',
  dictionaryCategory: '字典分类',
  dictionaryItemDetail: '字典项详情',
  itemCode: '选项编码',
  itemName: '选项名称',
  itemNameEn: '英文名称',
  sortOrder: '排序',
  enabledStatus: '启用状态',
  // agreement 字段
  agreementNo: '协议编号',
  agreementEntrustNo: '协议委托编号',
  agreementPeriod: '协议周期',
  agreementType: '协议类型',
  agreementQuota: '协议额度',
  agreementUnitPrice: '协议单价',
  agreedPalletCount: '协议板位数',
  occupiedQuota: '已占额度',
  remainingQuota: '剩余额度',
  origin: '始发港',
  palletStructure: '板位结构',
  palletStructureTotal: '板位结构（总量）',
  palletDetail: '板位明细',
  palletInfo: '板位信息',
  uldType: '板型',
  uldCount: '板数',
  chargeableWeightPerUld: '单板配合（计费重量）',
  chargeableWeightTotal: '计费重量合计',
  cycleTotalWeight: '周期总重(KG)',
  remainingWeight: '剩余重量',
  reservedWeight: '预留',
  cycle: '周期',
  period: '周期',
  subOrderNo: '子协议编号',
  executionMethod: '执行方式',
  volumeWeight: '计费重量配额',
  usageStatus: '使用情况',
  batchGenerationCycle: '批量生成周期：',
  productDate: '产品日期',
  allocationTimes: '权重份数',
  allocatedPalletCount: '分配板数',
  allocatedWeight: '分配计费重',
  // system 字段
  roleCode: '角色编码',
  roleName: '角色名称',
  roleNameEn: '英文角色名',
  dataScope: '数据权限',
  permissionCode: '权限编码',
  permissionName: '权限名称',
  permissionNameEn: '英文权限名',
  permissionType: '权限类型',
  parentPermission: '上级权限',
  routePath: '路由路径',
  componentPath: '组件路径',
  icon: '图标',
  orgCode: '组织编码',
  orgName: '组织名称',
  orgNameEn: '英文组织名',
  orgType: '组织类别',
  parentOrg: '上级组织',
  loginTime: '登录时间',
  ipAddress: 'IP地址',
  browser: '浏览器',
  os: '操作系统',
  failReason: '失败原因',
  configItem: '配置项',
  configKey: '配置键',
  configDescriptionEn: '英文描述',
  currentPrefix: '当前前缀',
  numberExample: '编号示例',
  currentValue: '当前值',
  lockedAt: '锁定时间',
  remainingLockTime: '剩余锁定时间',
  isLocked: '是否锁定',
  failCount: '失败次数',
  captchaRequired: '需要验证码',
  // cs-workbench fields
  isActualWeight: '已是实重',
  pieceTotal: '件数合计',
  volumeTotal: '体积合计',
  chargeWeightKg: '计费重(KG)',
  chargeWeightShort: '计费重',
  actualWeightShort: '实际重量',
  actualVolumeShort: '实际体积',
  actualChargeWeightShort: '实际计费重',
  bubbleChargeableWeight: '分泡后计费重',
  relatedProductOrderNo: '关联产品委托号',
  relatedMawbNo: '关联主单号',
  relatedHawbNo: '关联分单号',
  routeEtd: '航线ETD',
  routeStaff: '航线人员',
  grossWeightGw: '毛重(G.W)',
  volumeShort: '体积',
  originalRate: '原始单价',
  standardChargeableRatio: '标准计费重(1:166.667)',
  originalFreightSubtotal: '原始运费小计',
  otherSurchargeTotal: '其他附加费合计',
  originalTotalReceivable: '原始应收合计',
  baseChargeableRatio: '基准计费重(1:{ratio})',
  bubblePartWeight: '可分泡部分',
  customerReturnWeight: '客户享受返还',
  finalChargeable: '最终计费重',
  bubbleEffectiveRate: '分泡后单价(等效)',
  bubbleFreightSubtotal: '分泡后运费小计',
  bubbleEffectiveReceivable: '分泡后应收合计',
  discountAmount: '让利金额',
  // entry/dialogs 字段
  matchStatus: '匹配状态',
  urgency: '紧急程度',
  etd: 'ETD',
  bookedPieces: '委托件数',
  bookedWeight: '委托重量',
  bookedVolume: '委托体积',
  bookedChargeableWeight: '委托计费重',
  issueDate: '签发日期',
  placeOfIssue: '签发地点',
  deliveryTerms: '交货条款',
  freightPaymentMethod: '运费支付方式',
  volumetricWeight: '泡重',
  bubbleWeight: '吃泡',
  detailedDescription: '货物描述',
  marksNumbers: '唛头号码',
  address: '地址',
  contactInfo: '联系方式',
  allowedVolume: '允许体积',
  deviation: '体积偏差',
  independentCost: '独立成本',
  savingAllocation: '节省分配',
  actualAllocatedCost: '实际分摊成本',
  effectiveRate: '折合单价',
  weightDiff: '重量差异',
  volumeDiff: '体积差异',
  chargeableDiff: '计费重差异',
  dissolveReason: '撤舱原因',
  reasonDetail: '详细说明',
  // entry/dialogs/AddMasterAirWaybillDialog 字段
  actualFlightNo: '实际航班号',
  eta: 'ETA',
  bookedGrossWeight: '委托毛重',
  // entry/dialogs/CreateProductOrderDialog 字段
  selectAgreement: '选择协议',
  // entry/components 字段
  atd: 'ATD',
  ata: 'ATA',
  workDate: '工作日期',
  remark: '备注',
  chargeableWeightTotalKg: '计费重量合计（KG）',
  // entry/components/ChangeRequestDrawer 字段
  changeField: '变更字段',
  originalValue: '原值',
  newValue: '新值',
  changeReason: '变更原因',
  supplementaryNote: '补充说明',
  rejectReason: '驳回原因',
  // entry/components/CargoModeView 字段
  baseRate: '底价',
  // entry/components/MasterOrderItem/HawbDetailDialog 字段
  actualUldType: '实际板位',
  actualShipper: '实际发货人',
  actualConsignee: '实际收货人',
  shipper: '发货人',
  consignee: '收货人',
  volumetricWeightLabel: '体积重量',
  bubbleWeightShort: '泡重',
  bubbleSaving: '吃泡节省',
  // entry/components/RightPanel 字段
  weightRange: '重量段',
  specialAttr: '特殊属性',
  // entry/components/PendingWarehouseZone 字段
  bizOrderNoShort: '委托号',
  bubbleBaseRate: '吃泡底价',
  // entry/components/CenterPanel/MasterOrderList + MasterOrderItem + ProductOrderPanel
  mawbList: '主单号列表',
  hawbList: '分单列表',
  hawbListCount: '分单列表 ({count})',
  costPricing: '成本定价',
  trunkRateDefault: '干线单价(默认)',
  salesPriceTotal: '销售价合计',
  mawbPayableTotal: '应付合计',
  // entry/components/CenterPanel/ProductOrderPanel/MonitorSection 字段
  monitorMetrics: '信息汇总',
  matchedBizCount: '已匹配业务委托号',
  pendingWarehouse: '待入仓',
  warehoused: '已入仓',
  changePending: '变更待处理',
  // entry/components/RightPanel/MatchModeView 字段
  remaining: '剩余',
  // cs-workbench/components/CenterPanel/BizOrderForm/ProfitDashboard 字段
  costProfitDashboard: '成本与毛利看板',
  receivableTotal: '应收合计',
  salesBaseCostFormula: '销售底价成本（销售底价×计费重量）',
  // entry/components/CenterPanel/MasterOrderItem/MoInfoSection 字段
  masterInfo: '主单信息',
  actualTrunkRate: '航线结算单价',
  bookedChargeableWeightLong: '委托计费重量',
  actualChargeableWeightLong: '实际计费重量',
  actualGrossWeight: '实际毛重',
  // EQ成本计算改造新增字段
  bookedVolume: '委托体积',
  actualVolume: '实际体积',
  standardChargeableWeight: '标准计费重',
  airlineBilledCw: '航线计费重',
  airlineTotalCost: '航线总成本',
  eqAllocatedCost: '实际内部成本',
  eqAllocatedCostBase: 'EQ 分摊成本(协议池)',
  eqEffectiveRate: 'EQ 有效成本单价',
  trunkRateAverage: '干线单价(均价)',
  grossWeightTotal: '实际毛重(总)',
  volumeTotal: '实际体积(总)',
  standardChargeableWeightTotal: '标准计费重(总)',
  trunkChargeableWeight: '干线计费重',
  customerCwShort: '客户计费重',
  // 计算项悬停公式说明（label tooltip）
  trunkChargeableWeightFormula: '干线计费重 = Σ各主单号航线计费重',
  trunkRateAverageFormula: '干线单价(均价) = 干线总成本 ÷ 干线计费重',
  trunkTotalCostFormula: '干线总成本 = Σ各主单号航线总成本',
  eqAllocatedCostFormula: 'EQ 分摊成本 = 协议池总成本按吃泡偏离值内核分摊（独立成本 − 池节省 × |偏离值|占比；单成员 = 池总）',
  eqEffectiveRateFormula: 'EQ 有效成本单价 = EQ 分摊成本 ÷ 标准计费重(总)',
  grossWeightTotalFormula: '实际毛重(总) = Σ各业务委托实际毛重（已匹配/已入仓/变更待处理，实际缺失时委托值兜底）',
  volumeTotalFormula: '实际体积(总) = Σ各业务委托实际体积（已匹配/已入仓/变更待处理，实际缺失时委托值兜底）',
  standardCwTotalFormula: '标准计费重(总) = 取整(Max(实际毛重(总), 实际体积(总) ÷ 0.006))',
  // entry/components/LeftPanel/ProductOrderCard 字段
  mawbShort: '主单',
  bizShort: '业务',
  hawbShort: '分单',
  // cs-workbench/components/RightPanel/SmartAssistPanel 字段
  customerProfile: '客户画像',
  monthOrderCount: '本月订单',
  monthCargoVolume: '本月货量',
  monthSalesAmount: '本月销售额',
  routeRecommendation: '航线推荐',
  // entry/components/CenterPanel/MasterOrderItem/HawbCard 字段
  bubbleCost: '吃泡后成本',
  weightDiffShort: '重量差',
  // cs-workbench/components/CenterPanel/BizOrderForm/WarehouseDataSection 字段
  backfillBy: '回填人',
  backfillAt: '回填时间',
}
